import React from 'react';
import { AppLayout, BreadcrumbGroup, Grid } from '@amzn/awsui-components-react';
import { ApplicationState } from 'modules/app/store';
import { ErrorRouter } from 'modules/error/components';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BulkEditSpend } from '../components';

export const BulkEdit = () => {
    const { t } = useTranslation('purchase');
    const applicationHealth = useSelector((state: ApplicationState) => state.applicationHealth);

    const breadcrumbItems = [
        { text: t('breadCrumbs.poList'), href: '/purchaseOrder' },
        {
            text: t('breadCrumbs.bulkUpload'),
            href: '#'
        }
    ];

    return (
        <AppLayout
            content={
                applicationHealth.showError ? (
                    <ErrorRouter errorStatusCode={applicationHealth.errorCode} />
                ) : (
                    <Grid gridDefinition={[{ colspan: 1 }, { colspan: 10 }, { colspan: 1 }]}>
                        <div></div>
                        <div>
                            <BreadcrumbGroup ariaLabel="Breadcrumbs" items={breadcrumbItems} />
                            <BulkEditSpend />
                        </div>
                        <div></div>
                    </Grid>
                )
            }
            toolsHide={true}
            navigationHide={true}
        />
    );
};
